import React from "react";
import { Icon, Button, Modal, Header, Popup, Divider } from "semantic-ui-react";
import Board from './../../drive/Activity/PracticeActivity';
import { dispatch } from '@rematch/core';
import ArrangementPane from './ArrangementPane'
import BreadCrumbsPage from './../../drive/cards/BreadCrumbs'
import AddPhases from './../../drive/modals/AddPhasesModal';
import AddActivity from './../../drive/modals/AddActivityModal'
import EllipsisTooltip from './../../../../common/EllipsisTooltip'
import { withRouter } from 'react-router-dom';
import CircularDependencies from '../../../../common/CircularDependencies';
import { toastr } from 'react-redux-toastr';
import PlaybookActivityCard from '../../drive/cards/PlaybookActivityCard'
import RegenatePlaybookActivitiesModal from "./RegenatePlaybookActivitiesModal";
const Graph = require('graph.js/dist/graph.full.js');
let treeArray = [];
class PracticeFlowActivity extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			tree: {},
			laneId: '',
			eventBus: {},
			generateDetailsOpen:false,
			generateActivitiesFlag : false,
		}
		this.setCurrentLane = this.setCurrentLane.bind(this);
		this.onKeyPressed = this.onKeyPressed.bind(this);
	}

	async UNSAFE_componentWillMount() {
		dispatch.app.setRouteParams(this.props.match.params)
		await dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(this.props.match.params.playbookId);
		await dispatch.lifeCycle.getActivitiesCompletionPercentage();

		//dispatch.createPack.clearDataForSelectedActivity();
		dispatch.lifeCycle.disableLinking();
		dispatch.lifeCycle.showResourecePane(null);
		dispatch.lifeCycle.displaySecondMenu("Activities");
		// dispatch.createPack.showDuplicateIcon(false);
		document.addEventListener("keydown", this.onKeyPressed.bind(this));
		dispatch.lifeCycle.setArrangementPaneActiveButtonFlag("Sequence")
	}

	componentWillUnmount() {

		document.removeEventListener("keydown", this.onKeyPressed.bind(this));
	}
	componentDidMount() {
		dispatch.lifeCycle.setGraph(this.props.graph)
	}
	generateGraph = async (graph) => {
		this.createGraph(this.props.selectedPracticeLibrary.activities, null, graph)
	}
	createGraph = function (activities, parent, graph, isSequential) {
		try {
			if (activities && activities.length > 0) {

				for (const [index, activity] of activities.entries()) {

					const graphObject = {
						name: activity.name,
					}
					graph.addVertex(activity._id.toString(), graphObject);

					if (parent) {
						graph.addEdge(parent._id.toString(), activity._id.toString());
					}
					if (activity.dependencies && activity.dependencies.length > 0) {
						for (const dependency of activity.dependencies) {
							if (!graph.hasVertex(dependency.toString())) {

								graph.ensureVertex(dependency.toString(), { details: "temp ref" });
							}


							graph.addEdge(activity._id.toString(), dependency.toString())
						}
					}
					this.createGraph(activity.activities, activity, graph);
				}
			}
		}
		catch (e) {
			console.error('Error while cerating the initiative graph ', e);
		}
	}

	handleCardClick = (e, card) => {
		// Phase click
		if (!this.props.enableLinkActivity) {
			dispatch.createPack.showDuplicateIcon(true);
			dispatch.lifeCycle.showResourecePane("PracticeCommunitySwimLineCommanPane")
			dispatch.createPack.getSelectedActivityAsync(card._id)
			dispatch.createPack.activityUniqueIdSet(card._id)
			dispatch.app.setCollapsedResourcePaneIndexTemp(null)
			dispatch.lifeCycle.splitAt("60%");
			dispatch.lifeCycle.disableLinking();
		}

	}
	setCurrentLane(title, id) {
		this.setState({ laneId: id, laneName: title })
	}
	setEventBus = (handle) => {
		this.setState({ eventBus: handle })
	}
	openModelBox(e, tree) {
		this.setState({ tree: tree });
		dispatch.createPack.PhaseModalOpen(true);


	}
	activityModal = () => {
		return (
			<AddPhases isPhaseAddFlag={this.props.isPhaseAddFlag}
				tree={this.state.tree}
				selectedPracticeLibrary={this.props.selectedPracticeLibrary}
				user={this.props.user}
			/>
		);
	}
	getColor(id, communities) {
		if (!id)
			return '#fff'
		for (let community of communities) {
			if (community._id.toString() === id.toString()) {
				return community.tagColor;

			}
			for (let subcommunity of community.communities) {
				if (subcommunity._id.toString() === id.toString()) {
					return subcommunity.tagColor;
				}
			}
		}
	}

	validateCircularDependencies = async () => {

		let graph = new Graph();
		await this.generateGraph(graph);
		this.props.selectedPracticeLibrary.cycles = [];
		if (graph.cycle() && graph.cycle().length > 0) {

			for (let cycle of graph.cycles()) {
				this.props.selectedPracticeLibrary.cycles.push(cycle);
			}
		}
		if (this.props.selectedPracticeLibrary.cycles.length === 0) {
			this.setState({ cycles: null, circularDependencies: false })
			toastr.success('Message', `No circular dependencies found. Validation successful.`)
		}
		else {
			this.setState({
				cycles: <div style={{ maxHeight: '350px', overflowY: 'auto' }}><CircularDependencies selectedEntity={this.props.selectedPracticeLibrary} color={'#e09441'} /></div>,
				circularDependencies: true
			})

		}
	}
	generateActivities = async () => {
		this.setState({ generateActivitiesFlag : true })
		await dispatch.lifeCycle.getLeafNodeActivities();
		this.setState({ generateActivitiesFlag : false })
	}

	generateDetails = async (payload) => {
		
		this.setState({generateDetailsOpen:payload})
	};
	closeModal = () => {
		this.setState({ circularDependencies: false })
	}
	removeAllDependencies = async () => {
		let ids = [];
		for (let i = 0; i < this.props.selectedPracticeLibrary.cycles.length; i++) {
			ids.push(this.props.selectedPracticeLibrary.cycles[i][this.props.selectedPracticeLibrary.cycles[i].length - 1])
		}
		await dispatch.lifeCycle.removeAllDependenciesFromPlaybook(ids);
		this.setState({ circularDependencies: false })
	}
	onKeyPressed(e) {
		if (e.keyCode === 27) {
			if (this.props.enableLinkActivity) {
				dispatch.lifeCycle.disableLinking();
			}
		}
	}
	addEdge = (fromVertex, toVertex) => {
		dispatch.lifeCycle.addEdge({ fromVertex: fromVertex, toVertex: toVertex })
	}
	removeEdge = (fromVertex, toVertex) => {
		dispatch.lifeCycle.removeEdge({ fromVertex: fromVertex, toVertex: toVertex })
	}
	generateActivitiesFlag = () => {	
		if(this.props.selectedPracticeLibrary 
			&& !this.state.generateActivitiesFlag
			&& typeof this.props.selectedPracticeLibrary.playbookGenerationStatus !== 'undefined' 
            && this.props.selectedPracticeLibrary.playbookGenerationStatus >= 0  
			&& this.props.selectedPracticeLibrary.genParams 
			&& this.props.selectedPracticeLibrary.genParams.length > 0
			&& this.props.selectedPracticeLibrary.activities
			&& this.props.selectedPracticeLibrary.activities.length > 0
			&& this.props.selectedPracticeLibrary.activities[0].activities
			&& this.props.selectedPracticeLibrary.activities[0].activities.length > 0
		    && this.props.selectedPracticeLibrary.activities[0].activities.some(activity=>activity.activities && activity.activities.length === 0)){
			return false;
		} else {
			return true;
		 }
	}
	generateDetailsFlag = () => {	
		if(this.props.selectedPracticeLibrary 
            && typeof this.props.selectedPracticeLibrary.playbookGenerationStatus !== 'undefined'   
			&& this.props.selectedPracticeLibrary.genParams 
			&& this.props.selectedPracticeLibrary.genParams.length > 0
			&& this.props.selectedPracticeLibrary.playbookGenerationStatus !== 1){
			return false;
		} else {
			return true;
		 }
	}
	render() {
		const { percentageGenerationComplete, percentageActivitesGenerated,selectedPracticeLibrary } = this.props;
		treeArray = this.props.selectedPracticeLibrary.activities;
		let communities = this.props.selectedPracticeLibrary.communities;
		const integrate = this.props.selectedAccount.integrations && this.props.selectedAccount.integrations.some(int => int.isActive && int.id.id === "openai")
		const isPlaybookGenerated = this.props.selectedPracticeLibrary && 
        typeof this.props.selectedPracticeLibrary.playbookGenerationStatus !== 'undefined' && 
        this.props.selectedPracticeLibrary.playbookGenerationStatus >= 0
		treeArray && treeArray.map((tree) => {
			if (tree.raci && tree.raci.a) {
				tree.communityTagColor = this.getColor(tree.raci.a, communities);
			}

			if (tree.activities) {
				tree.lanes = tree.activities.length > 0 ? tree.activities.filter((activity) => { return activity.isParentNode }) : [];
				let leafNodes = tree.activities.filter((activity) => { return activity.isLeafNode })

				tree.lanes.map((lane) => {
					lane.title = lane.name;
					lane.stageId=lane._id
					if (lane.raci && lane.raci.a) {
						lane.communityTagColor = this.getColor(lane.raci.a, communities);
					}

					lane.cards = lane.activities.length > 0 ? lane.activities : [];
					lane.label = lane.cards.length > 0 ? lane.cards.length : '0';
					lane.cards.map((card) => {
						if (card) {
							if (card.raci && card.raci.a) {
								card.communityTagColor = this.getColor(card.raci.a, communities);
							}
							card.title = card.name;
						}

					})
				})

				let setColor;
				if (leafNodes.length > 0) {

					leafNodes.map((card) => {
						card.title = card.name;

						if (card.raci && card.raci.a) {
							card.communityTagColor = this.getColor(card.raci.a, communities);
						}
					})

					if (tree.raci && tree.raci.a) {
						setColor = this.getColor(tree.raci.a, communities);
					}
					let lane = {
						_id: tree._id,
						title: "Others",
						cards: leafNodes,
						label: leafNodes.length,
						communityTagColor: setColor,
						isDummy: true
					};
					tree.lanes.push(lane)
				}
				else if (tree.lanes.length === 0) {
					let lane = {
						_id: tree._id,
						title: "Others",
						cards: [],
						label: 0,
						communityTagColor: setColor,
						isDummy: true
					};
					tree.lanes.push(lane)
				}
			}
		})
		let height = this.props.componentDesignerDimension;
		treeArray = Object.assign([], treeArray);
		
		return (
			<div className="containerBox" onKeyDown={this.onKeyPressed}>
				<ArrangementPane {...this.props} setPage="Sequence" />
				<div>
					<BreadCrumbsPage {...this.props} />
					{this.props.selectedPracticeLibrary.status === 0 &&
						<div
							className="pull-right"
							style={{
								position: "absolute",
								top: "12px",
								right: "56px"
							}}>
							<div style={{display:"flex", alignItems:"center"}}>
							{percentageGenerationComplete && (
								<div style={{
									minWidth: '300px',
									backgroundColor: '#71797E', 
									borderRadius: '5px',
									overflow: 'hidden',
									position: 'relative',
									height: '30px',
									marginRight:'10px',
								}}>
									<div style={ {
										height: '100%',
										width: `${percentageGenerationComplete}%`,
										backgroundColor: '#90EE90',
										transition: 'width 0.5s ease-in-out',
										}}></div>
									<div style={{
											position: 'absolute',
											top: '50%',
											left: '50%',
											transform: 'translate(-50%, -50%)',
											color: 'white',
											fontWeight: 'bold',
											width:"300px"
											}}>
										<div style={{display:"flex", paddingLeft:"10px"}}><Icon name='circle notched' size='large' loading/>
										<div style={{marginLeft:'0.5rem'}}>
											{`Activities generation in progress - ${ percentageGenerationComplete } %`}
										</div></div>
									</div>
								</div>
								)}
							{selectedPracticeLibrary && selectedPracticeLibrary.playbookGenerationStatus === 1 && (selectedPracticeLibrary.percentageActivitesGenerated || selectedPracticeLibrary.percentageActivitesGenerated === 0) && (
								<div style={{
									minWidth: `${selectedPracticeLibrary.generativeLogs && selectedPracticeLibrary.generativeLogs.activityGenerationAttempt === 1 ? "340px" : "380px"}`,
									backgroundColor: '#71797E', 
									borderRadius: '5px',
									overflow: 'hidden',
									position: 'relative',
									height: '30px',
									marginRight:'10px',
								}}>
									<div style={ {
										height: '100%',
										width: `${selectedPracticeLibrary.percentageActivitesGenerated}%`,
										backgroundColor: '#90EE90',
										transition: 'width 0.5s ease-in-out',
										}}></div>
									<div style={{
											position: 'absolute',
											top: '50%',
											left: '50%',
											transform: 'translate(-50%, -50%)',
											color: 'white',
											fontWeight: 'bold',
											width:`${selectedPracticeLibrary.generativeLogs && selectedPracticeLibrary.generativeLogs.activityGenerationAttempt === 1 ? "340px" : "380px"}`
											}}>
										<div style={{display:"flex", paddingLeft:"10px"}}><Icon name='circle notched' size='large' loading/>
										<div style={{marginLeft:'0.5rem'}}>
										{selectedPracticeLibrary.generativeLogs && selectedPracticeLibrary.generativeLogs.activityGenerationAttempt === 1 ? "Activities details generation in progress" : "Failed Activities details re-generation in progress"} - { selectedPracticeLibrary.percentageActivitesGenerated } %
										</div></div>
									</div>
								</div>
								)}	
							{integrate && isPlaybookGenerated && <div><Button
								size='mini'
								className="button-info"
								disabled={this.props.generatingActivityDetails || this.generateDetailsFlag()}
								onClick={this.generateDetails}>Generate Details</Button>
								<Popup hoverable className="popupStyled " wide='very' position='bottom right' inverted trigger={
									<Icon style={{marginBottom:"10px",marginRight:"10px"}} name='info circle' size='large' />
								}
									content={<div style={{ display: 'block', width: '400px', whiteSpace:'normal', wordWrap:"break-word" }}>This will generate new attachments links and metadata for activities in "{selectedPracticeLibrary.name}".</div>}
								/></div>}	
							<Button
								size='mini'
								className="button-info"
								onClick={this.validateCircularDependencies}>Validate</Button>
							<Popup hoverable className="popupStyled " wide='very' position='bottom right' inverted trigger={
								<Icon style={{marginBottom:"10px",marginRight:"10px"}} name='info circle' size='large' />
							}
								content={<div style={{ display: 'block', width: '100%' }}><b>Validate Dependencies</b><br />This is to ensure activities are not causing <a href="https://en.wikipedia.org/wiki/Circular_dependency" rel="noopener noreferrer" target="_blank">circular reference</a>.</div>}
							/></div>
						</div>}
				</div>

				<div className="activityTable overflowAuto" >
					<div className="mainBox overflow-hide"
						style={{
							maxHeight: (height.windowHeight - height.height) - 130,
							minHeight: (height.windowHeight - height.height) - 130,
							'width': this.props.componentDesignerDimension.width - 80
						}}>
						{treeArray && treeArray.length > 0 && treeArray.map(function (tree, index) {
							if (tree.lanes) {
								let setWidth = tree.lanes && tree.lanes.length === 1 ?
									150 : tree.lanes.length * 160
								return (
									<div className="childBox" key={index} >
										<div
											onClick={e => this.handleCardClick(e, tree)}
											className="phaseHeading"
										>

											<div className="addPhaseBtn">
												{this.props.selectedPracticeLibrary.status === 0 &&

													<Popup
														hoverable
														className="popupStyled "
														wide='very'
														position='bottom right'
														inverted
														trigger={
															<Icon
																style={!this.props.selectedPracticeFlowActivity.parentActivity && this.props.selectedPracticeFlowActivity.isParentNode && this.props.selectedPracticeFlowActivity._id === tree._id ? { color: "white" } : { color: "#3EA2F7" }}
																name="plus"
																onClick={event => this.openModelBox(event, tree)} />
														}
														content="Add activity under phase"
													/>
												}
											</div>
											<PlaybookActivityCard
												type="phase"
												page="sequence"
												selectedPracticeLibrary={this.props.selectedPracticeLibrary}
												activityData={tree}
												selectedActivity={this.props.selectedPracticeFlowActivity}
												enableLinkActivity={this.props.enableLinkActivity}
												communities={this.props.selectedPracticeLibrary.communities}
												_id={tree._id}
												user={this.props.user}
          										currentOrganization={this.props.currentOrganization}
											/>
										</div>
										<Board
											data={tree}
											selectedPracticeLibrary={this.props.selectedPracticeLibrary}
											draggable={this.props.selectedPracticeLibrary.status == 0}
											hideCardDeleteIcon={this.props.selectedPracticeLibrary.status !== 0}
											editable
											collapsibleLanes
											id={tree._id}
											eventBusHandle={this.state.eventBus}
											setCurrentLane={this.setCurrentLane}
											graph={this.props.graph}
											addEdge={this.addEdge}
											removeEdge={this.removeEdge}
											canAddLanes={true}
											{...this.props} />
									</div>
								);
							}
						}, this)}
					</div>
				</div>
				{this.activityModal()}
				<AddActivity objectId={this.state.laneId} title={this.state.laneName} isAddActivityModalOpen={false} branchID={this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.branches && this.props.selectedPracticeLibrary.branches[0]} {...this.props} />
				<Modal
					open={this.state.circularDependencies}
					onClose={this.closeModal}
					size='small'
					className="basicModal"
					closeOnEscape={false}
					closeOnDimmerClick={false}
					closeIcon
				>
					<Modal.Header>Circular dependencies found</Modal.Header>
					<Modal.Content>
						{this.state.cycles}
					</Modal.Content>
					<Modal.Actions className="actionInFormcy">
						<Button
							id='removeDependencies'
							className="button-warning float-right"
							type="submit"
							onClick={this.removeAllDependencies}>Remove All</Button>
						<Button id='cancelBtn'
							className="button-cancel"
							type="button"
							onClick={this.closeModal}> Close</Button>
					</Modal.Actions>
				</Modal>
				<RegenatePlaybookActivitiesModal generateDetailsOpen={this.state.generateDetailsOpen} {...this.props} generateDetails={this.generateDetails}/>
			</div>
		);
	}
}
export default withRouter(PracticeFlowActivity);

